import { Children, cloneElement, isValidElement, ReactNode } from 'react';
import ItemMenu from '../ItemMenu';

const SairBtn = ({ children }: { children: ReactNode }) => {
	const ItemMenuButton = Children.map(children, (child) => {
		if (isValidElement(child) && child.type === ItemMenu) {
			return cloneElement(child as React.ReactElement<{ className?: string }>, {
				className: 'w-[123px] flex items-center justify-center !text-[#E01E5A] [&>*]:!text-[#E01E5A] [&_svg]:!stroke-[#E01E5A] [&>div]:w-auto',
			});
		}
		return null;
	});

	return <>{ItemMenuButton}</>;
};

export default SairBtn;
